import { ConfirmDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';

interface ApproveRevisionProps {
  loanId: number;
  draw: any;
  hasRevisedSowForm?: boolean;
  afterActionExecuted: () => void;
}

export const ApproveRevision = observer(({ loanId, draw, hasRevisedSowForm = false, afterActionExecuted }: ApproveRevisionProps) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const body = `You are about to start a revision approval process for the SOW revision #${draw.drawNumber} - Loan ${loanId}.\n
                                      ${hasRevisedSowForm ? `When completed, the SOW revision will replace the original Scope of Work.\n` : ''}
                                      Do you want to continue?`;

  const confirmHandler = () => {
    drawActionsStore.approveRevision(draw.drawId, afterActionExecuted);
  }

  return (
    <ConfirmDialog
      open={drawActionsStore.isApproveRevisionDialogOpen}
      confirmButtonText='Confirm'
      handleClose={() => drawActionsStore.setIsApproveRevisionDialogOpen(false)}
      handleCancel={() => drawActionsStore.setIsApproveRevisionDialogOpen(false)}
      handleConfirm={confirmHandler}
      title={'Approve Revision'}
      body={body}
    />
  );
});
